export class LabelFilter {
  key: string
  requestKey: string
  label: string
  value: string
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/common/search/label-filter.ts